import { Config as ConfigObj } from './services';

export { languageCodeByCountry, siteNames } from './services';
export const Config = ConfigObj();
